export const FORMATS = ['native', 'text', 'markdown', 'slate'] as const;

export const HOST_STYLE_ID = 'mu-txt-host-style';
